import React from "react";
import routes from "../config/routes";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { Box } from "reflexbox/styled-components";
import panelsSvg from "./../assets/images/panels.svg";
import speakersSvg from "./../assets/images/speakers.svg";
import locationSvg from "./../assets/images/location.svg";
import sponsorsSvg from "./../assets/images/sponsors.svg";
import { withLocalizeStrings } from "../languages/Localize";
import ForumCountdown from "../components/forum-countdown/ForumCountdown";
import { useApplicationStateValue } from "../application/Application";
// import MountainButton from "../components/buttons/mountain-button/MountainButton";
import RenderIf from "../common/conditions/RenderIf";
import ActualPanels from "../panels/actual-panels/ActualPanels";
import { checkIfIOS } from "../util/util";
import SignUpButton from "../components/buttons/mountain-button/SignUpButton";

const StyledHomeContainer = styled(Box).attrs(() => ({ height: "80%" }))`
    display: grid;
    grid-template-rows: 55% 7% 40%;
`;

const IOSStyledHomeContainer = styled(Box).attrs(() => ({ height: "80%" }))`
    display: grid;
    grid-template-rows: 55% 7% 40%;
`;

const StyledNavigationContainer = styled(Box)`
    display: grid;
    grid-template-columns: 34vw 34vw;
    grid-template-rows: 34vw 34vw;
    grid-gap: 2vw;
`;

const StyledTitle = styled(Box).attrs(() => ({ color: "white", fontWeight: "semiBold", fontSize: 6 }))`
    // justify-self: center;
    text-align: center;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

const StyledTitleSecond = styled(Box).attrs(() => ({ color: "white", fontWeight: "semiBold", fontSize: 6 }))`
    // justify-self: center;
    text-align: center;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
  //  margin-bottom: 3vw;
    margin-bottom: 1.5vh;
`;

const StyledSubTitle = styled(Box).attrs(() => ({ color: "white", fontWeight: "semiBold", fontSize: 4 }))`
    //  justify-self: center;
    text-align: center;
    // margin-bottom: 10vw;
    margin-bottom: 4vh;
`;

const IOSStyledNavigationContainer = styled(Box)`
    display: grid;
    grid-template-columns: 34vw 34vw;
    grid-template-rows: 30vw 30vw;
    grid-gap: 2vw;
`;

const StyledNavigation = styled(NavLink).attrs(props => ({ to: props.to || routes.PANELS }))`
    display: grid;
    grid-template-rows: 70% 30%;
    grid-template-columns: 100%;
    background: ${({ theme }) => theme.colors.white};
    border-radius: 15px;
    &:hover,
    &:active {
        background: ${({ theme }) => theme.colors.white};
    }
`;
const StyledNavigationIcon = styled(Box)`
    height: 24vw;
    width: 24vw;
    &.panels {
        background: url(${panelsSvg}) no-repeat;
        background-size: 100% 100%;
    }
    &.speakers {
        background: url(${speakersSvg}) no-repeat center;
        background-size: 100% 100%;
    }
    &.location {
        background: url(${locationSvg}) no-repeat center;
        background-size: 100% 100%;
    }
    &.sponsors {
        background: url(${sponsorsSvg}) no-repeat center;
        background-size: 100% 100%;
    }
    justify-self: center;
    align-self: center;
`;

const StyledNavigationLabel = styled(Box).attrs(() => ({ color: "primary", fontWeight: "semiBold", fontSize: 3 }))`
    align-self: center;
    justify-self: center;
`;

const StyledBadgeContainer = styled(Box).attrs(() => ({ height: "100%" }))`
    display: grid;
    width: 100%;
    grid-template-columns: 90%;
    grid-template-rows: 30% 1fr 30%;
    align-items: center;
    justify-content: center;
`;

const Home = ({ strings, history }) => {
    const {
        appData: { forumStartTime },
        started
    } = useApplicationStateValue();

    let HomeContainer = StyledHomeContainer;
    let NavigationContainer = StyledNavigationContainer;

    if (checkIfIOS()) {
        HomeContainer = IOSStyledHomeContainer;
        NavigationContainer = IOSStyledNavigationContainer;
    }

    return (
        <>
            <StyledTitle>{strings.home.TITLE}</StyledTitle>
            <StyledTitleSecond>{strings.home.TITLESECOND}</StyledTitleSecond>
            <StyledSubTitle>{strings.home.SUBTITLE}</StyledSubTitle>
            <HomeContainer>
                <NavigationContainer marginY={[2, 3, 4]} marginX="auto">
                    <StyledNavigation to={routes.PANELS}>
                        <StyledNavigationIcon className="panels" />
                        <StyledNavigationLabel>{strings.menu.PANELS}</StyledNavigationLabel>
                    </StyledNavigation>
                    <StyledNavigation to={routes.SPEAKERS}>
                        <StyledNavigationIcon className="speakers" />
                        <StyledNavigationLabel>{strings.menu.SPEAKERS}</StyledNavigationLabel>
                    </StyledNavigation>
                    <StyledNavigation to={routes.SPONSORS}>
                        <StyledNavigationIcon className="sponsors" />
                        <StyledNavigationLabel>{strings.menu.SPONSORS}</StyledNavigationLabel>
                    </StyledNavigation>
                    <StyledNavigation to={routes.LOCATION}>
                        <StyledNavigationIcon className="location" />
                        <StyledNavigationLabel>{strings.menu.LOCATION}</StyledNavigationLabel>
                    </StyledNavigation>
                </NavigationContainer>
                {/*<MountainButton title={strings.home.ACCREDITATION} onClick={() => history.push(routes.REGISTER)} />*/}
                <Box margin={[2, 3, 3]} className={"aktuelni"}>
                    <RenderIf
                        render={() => (
                            <StyledBadgeContainer>
                                <ForumCountdown to={forumStartTime} />
                                <SignUpButton path={"web:https://jahorinaekonomskiforum.com/?page_id=10"} />
                                {/*<MountainButton title={strings.home.SIGN_UP} onClick={() => history.push(routes.REGISTER, { screen: "LOGIN" })} />*/}
                            </StyledBadgeContainer>
                        )}
                        if={!started}
                    />
                    <RenderIf render={() => <ActualPanels />} if={started} />
                </Box>
            </HomeContainer>
        </>
    );
};

export default withLocalizeStrings(Home);
